__webpack_require__.p = "/legionnaireplus-talent-calculator/";